<template>
    <paper class="loader-salary-confirm">
        <!-- <div class="tips">每月1号获取委派函启用的数据，请及时维护发薪日期，无配置不会自动发送短信</div> -->
        <MPane
            :class="{ 'loader-salary-confirm-supplier-pane': isSupplier }"
            ref="paneRef"
            :config="config"
            :totalData="totalData"
            :pageTotal="page.pageTotal"
            :loading="loading"
            :currentPage="page.currentPage"
            :initSearchInfo="initSearchInfo"
            searchId="loaderSalaryConfirmSearch"
            pageID="loaderSalaryConfirmPage251211"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @record-btn="handleRecord"
            @repush-btn="handleRepush"
            @btnClick="handleBtnClick"
            @progress-btn="viewProgress"
            @detail-btn="viewDetail"
            @row-db-click="viewDetail"
            @selectChange="handleSelect">
            <div slot="table-module-btn">
                <el-button
                    v-has="'/loaderSalaryConfirm-10'"
                    size="mini"
                    :icon="isSensitive ? 'icon-show' : 'icon-hidden'"
                    @click="handleSensitive"></el-button>
                <el-tooltip effect="dark" content="导入" placement="bottom">
                    <el-button icon="el-icon-upload2" size="mini" @click="onImport"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        class="bigData-btn-export"
                        :loading="exportLoading"
                        @click="handleExport"></el-button>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <el-button class="bigData-btn-batchRepush" type="primary" :loading="repushLoading" @click="sendMsg"> 短信发送</el-button>
                
                <!-- <el-button
                    v-if="!isSupplier"
                    class="bigData-btn-batchRepush"
                    type="primary"
                    :loading="repushLoading"
                    @click="handleRepushAll">
                    重推
                </el-button>-->
                <el-button type="primary" @click="showApproveDialog">闭环申请</el-button>
                <el-button type="primary" @click="showReasonDialog">薪资未发处理</el-button>
            </div>
        </MPane>
        <RecordDialog ref="rdRef" />
        <ApproveDialog ref="approveRef" @refresh="loadData" />
        <ReasonDialog ref="reasonRef" @refresh="loadData" />
        <ImportDialog ref="importDialog" @reload="loadData" :exportTemplate="templateDownload" />
    </paper>
</template>

<script>
import { filePreview } from '@/utils/filePreview.js'
import { dictWithUrl } from '@/components/lots/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import bigDataLog from '@/utils/bigDataLog'
import Paper from '@/components/core/paper/Paper'
import MPane from '@/components/supplierPanel'
import RecordDialog from './RecordDialog.vue'
import { APPLY_TYPES_MAIN } from '../../../constant/contractConstant.js'
import { SALARY_REASON_AUDIT_STATUS } from '../../../constant/constant.js'
import config from './config.js'
import supConfig from './supConfig.js'
import common from '../../../api/common.js'
import { getSensitiveVal } from '../../../utils/common.js'
import {
    manageSearch,
    lsrmExport,
    rePush,
    supSearch,
    lspExport,
    checkRePush,
    templateDownload,
    sendSms,
} from '../../../api/warehouseResourceManagement/loaderSalaryConfirm.js'
import ApproveDialog from './approveDialog.vue'
import ReasonDialog from './reasonDialog.vue'
import ImportDialog from './importDialog.vue'
// 根据字典 SALARY_CONFIRM_STATUS 加类名；1未确认，2已收到，3未收到
const COMFIRM_STATUS = {
    NOT_CONFIRM: '1',
    RECEIVED: '2',
    NOT_RECEIVED: '3',
}

const COMFIRM_STATUS_CLASS_NAME = {
    [COMFIRM_STATUS.NOT_CONFIRM]: 'salary-not-operate',
    [COMFIRM_STATUS.RECEIVED]: 'salary-operate-success',
    [COMFIRM_STATUS.NOT_RECEIVED]: 'salary-operate-fail',
}

const START_TIME = dayjs().subtract(30, 'd').format('YYYY-MM-DD') + ' 00:00:00'
const END_TIME = dayjs().format('YYYY-MM-DD') + ' 23:59:59'

export default {
    name: 'loaderSalaryConfirm',
    components: { Paper, MPane, RecordDialog, ApproveDialog, ReasonDialog, ImportDialog },
    data() {
        return {
            templateDownload,
            isSensitive: true,
            initSearchInfo: {
                // createTimeArr: [START_TIME, END_TIME],
                confirmStatusList: ['3'],
            },
            searchObj: {
                // createTimeArr: [START_TIME, END_TIME],
                confirmStatusList: ['3'],
            },
            loading: false,
            repushLoading: false,
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0,
            },
            exportLoading: false,
            totalData: [],
            selecteList: [],
            dictData: {},
        }
    },
    computed: {
        ...mapGetters(['currentTenant']),
        isSupplier() {
            return !!this.$store.state.supplier
        },
        config() {
            return this.isSupplier ? supConfig : config
        },
    },
    mounted() {
        let { warehouseWorkerNo, month, confirmStatusList } = this.$route.query
        if (!this.isSupplier && warehouseWorkerNo && month && confirmStatusList) {
            confirmStatusList = confirmStatusList.split(',')
            this.initSearchInfo = { warehouseWorkerNo, month, confirmStatusList }
            this.searchObj = { warehouseWorkerNo, month, confirmStatusList }
        } else if (this.isSupplier && confirmStatusList) {
            confirmStatusList = confirmStatusList.split(',')
            this.$refs.paneRef.$refs.searchList.setQueryParams({
                confirmStatusList
            })
            this.searchObj = { confirmStatusList }
        }
        dictWithUrl('NO_PAY_SALARY_REASON,BUSINESS_SCENE').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                this.loadData()
            }
        })
    },
    activated() {
        let { warehouseWorkerNo, month, confirmStatusList } = this.$route.query
        if (!this.isSupplier && warehouseWorkerNo && month && confirmStatusList) {
            confirmStatusList = confirmStatusList.split(',')
            this.initSearchInfo = { warehouseWorkerNo, month, confirmStatusList }
            this.searchObj = { warehouseWorkerNo, month, confirmStatusList }
        } else if (this.isSupplier && confirmStatusList) {
            confirmStatusList = confirmStatusList.split(',')
            this.$refs.paneRef.$refs.searchList.setQueryParams({
                confirmStatusList
            })
            this.searchObj = { confirmStatusList }
        }
        dictWithUrl('NO_PAY_SALARY_REASON,BUSINESS_SCENE').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                this.loadData()
            }
        })
    },
    methods: {
        viewDetail(row){
            if(!this.isSupplier){
                this.$router.push(`/loaderSalaryDetail?id=${row.id}`)
            }
        },
        handleBtnClick(val, index, row) {
            const fileObj = {
                fileName: row.fileName,
                fileId: row.fielId,
                fileUrl: row.fileUrl,
            }
            filePreview(fileObj)
        },
        onImport() {
            this.$refs.importDialog.handleVisible(true)
        },
        showReasonDialog() {
            if (!this.selecteList.length) return this.$message.warning('请选择数据')
            this.$refs['reasonRef'].init(this.selecteList)
        },
        checkSameValue(arr) {
            //查询勾选的每条数据相同的分公司并返回
            const sameValue = arr.every(obj =>
                obj.companyCode.some(val => arr.every(obj2 => obj2.companyCode.includes(val))),
            )
                ? {
                      companyCode: [
                          ...new Set(
                              arr.reduce(
                                  (acc, obj) => acc.filter(val => obj.companyCode.includes(val)),
                                  arr.flatMap(obj => obj.companyCode),
                              ),
                          ),
                      ],
                      companyName: [
                          ...new Set(
                              arr.reduce(
                                  (acc, obj) => acc.filter(val => obj.companyName.includes(val)),
                                  arr.flatMap(obj => obj.companyName),
                              ),
                          ),
                      ],
                  }
                : {}
            return sameValue
        },
        transformObject(arr) {
            return arr.companyCode.map((code, index) => ({
                companyCode: code,
                companyName: arr.companyName[index],
            }))
        },
        showApproveDialog() {
            if (!this.selecteList.length) return this.$message.warning('请选择数据')
            if (this.selecteList.length > 50) return this.$message.warning('最多选择50条数据')
            //同一分公司 && 工资确认=(未收到||未确认) && 审批状态≠(审批中||审批通过) && 薪资未发原因和原因备注有值, 支持提交审批
            const sameValue = this.checkSameValue(
                this.selecteList.map(s => {
                    return {
                        companyCode: s.companyCode.split(','),
                        companyName: s.companyName.split(','),
                    }
                }),
            )
            //业务场景一致
            const sameBusinScence = [...new Set(this.selecteList.map(v => v.businessScene))]
            if (
                sameValue.companyCode && sameBusinScence.length === 1 && 
                this.selecteList.every(
                    v =>
                        [COMFIRM_STATUS.NOT_CONFIRM, COMFIRM_STATUS.NOT_RECEIVED].includes(v.confirmStatus) &&
                        ![SALARY_REASON_AUDIT_STATUS.PENDING, SALARY_REASON_AUDIT_STATUS.ADOPT].includes(
                            v.auditStatus,
                        ) &&
                        v.noPaySalaryReason,
                )
            ) {
                this.$refs['approveRef'].init(this.transformObject(sameValue), this.selecteList)
            } else {
                this.$message.warning(
                    '请选择同一分公司，业务场景一致，工资确认=未收到或未确认,审批状态≠审批中或审批通过，薪资未发原因和原因备注有值的数据',
                )
            }
        },
        // 脱敏
        handleSensitive() {
            this.isSensitive = !this.isSensitive
            this.setSensitiveData()
            if (!this.isSensitive) {
                common.operationRecord({ operationModule: '仓储资源管理-装卸工费用确认' })
            }
        },
        setSensitiveData() {
            this.totalData.forEach(item => {
                this.$set(
                    item,
                    'idCardNo_',
                    this.isSensitive && item.idCardNo ? getSensitiveVal(item.idCardNo, 'idCard') : item.idCardNo,
                )
                this.$set(
                    item,
                    'workerPhone_',
                    this.isSensitive && item.workerPhone
                        ? getSensitiveVal(item.workerPhone, 'phone')
                        : item.workerPhone,
                )
            })
        },
        // 点击查询
        searchChange(data) {
            if (!this.validate(data)) {
                return false
            }
            this.page.pageNo = 1
            this.searchObj = data
            this.loadData()
        },
        // 切换分页页数
        pageChange(currentPage) {
            this.isSensitive = true
            this.page.pageNo = currentPage
            this.loadData()
        },
        // 切换分页显示条数
        sizeChange(pageSize) {
            this.isSensitive = true
            this.page.pageNo = 1
            this.page.pageSize = pageSize
            this.loadData()
        },
        validate(searchObj) {
            let valid = true
            if (this.isSupplier) {
                return valid
            }
            const keys = [
                'warehouseWorkerNo',
                'idCardNo',
                'workerName',
                'contractCode',
                'supplierCode',
                'companyCode',
                'businessName',
                'month',
                'confirmStatusList',
                'flowId',
                'physicalWarehouseCode',
                'logicalWarehouseCode',
            ]
            if (
                searchObj.createTimeArr &&
                searchObj.createTimeArr.length &&
                dayjs(searchObj.createTimeArr[1]).subtract(91, 'd').toDate() >
                    dayjs(searchObj.createTimeArr[0]).toDate()
            ) {
                this.$message.warning({
                    message: '查询最多查询3个月',
                })
                valid = false
            } else if (
                keys.every(key => !searchObj[key] || !searchObj[key].length) &&
                (!searchObj.createTimeArr || !searchObj.createTimeArr.length)
            ) {
                this.$message.warning({
                    message:
                        'MIP流程编码、仓库人员编码、身份证、仓库人员名称、合同名称、供应商名称、分公司名称、经营中心名称、月份、工资确认、逻辑仓、物理仓都为空时，时间范围必填',
                    duration: 5000,
                })
                valid = false
            }
            return valid
        },
        viewProgress(row) {
            this.$router.push({
                name: 'mipIframe',
                query: {
                    processId: row.flowId,
                    from: 'salary',
                    confirmCode: row.confirmCode,
                    path: '/loaderSalaryConfirm',
                },
            })
        },
        loadData() {
            const params = this.getParams()
            this.loading = true
            let api = manageSearch
            if (this.isSupplier) {
                //LSP
                api = supSearch
            }
            api(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.totalData = res.data.list.map(item => {
                            item.month_ = item.year && item.month ? `${item.year}年${item.month}月` : ''
                            item._confirmStatusClassName = COMFIRM_STATUS_CLASS_NAME[item.confirmStatus] || ''
                            item.hiddenEvent = item.confirmStatus === COMFIRM_STATUS.RECEIVED ? ['repush'] : []
                            item._noPaySalaryReason = item.noPaySalaryReason
                                ? item.noPaySalaryReason.split(',').map(v => this.dictData['NO_PAY_SALARY_REASON'][v]) +
                                  ''
                                : ''
                            item._businessScene = item.businessScene
                                ? item.businessScene.split(',').map(v => this.dictData['BUSINESS_SCENE'][v]) +
                                  ''
                                : ''
                            if (!item.flowId) item.hiddenEvent.push('progress')
                            return item
                        })
                        this.setSensitiveData()
                        this.page.pageTotal = res.data.totalCount
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        getParams() {
            const params = {
                ...JSON.parse(JSON.stringify(this.searchObj)),
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
            }
            if (params.month) {
                params.year = dayjs(params.month).format('YYYY')
                params.month = dayjs(params.month).format('MM')
            }
            if (params.createTimeArr && params.createTimeArr.length) {
                params.startTime = dayjs(params.createTimeArr[0]).format('YYYY-MM-DD HH:mm:ss')
                params.endTime = dayjs(params.createTimeArr[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            if (this.isSupplier) {
                params.supplierCode = this.$store.state.supplier.supplierCode
            }
            if (!params.noPaySalaryReasonList) {
                params.noPaySalaryReasonList = []
            }
            if (!params.auditStatusList) {
                params.auditStatusList = []
            }
            if (!params.confirmStatusList) {
                params.confirmStatusList = []
            }
            if (!params.salaryPaydayCodeList) {
                params.salaryPaydayCodeList = []
            }
            if (!params.businessSceneList) {
                params.businessSceneList = []
            }
            if (params.customerCode) {
                params.customerCodeList = params.customerCode.split(',')
                delete params.customerCode
                delete params.customerName
            }
            delete params.createTimeArr
            delete params.tenantCode
            delete params.applyType
            delete params.mainLogicalWarehouseName
            return params
        },
        //查询是否需要脱敏
        isSensitiveValue(prop) {
            let sensitiveValue = false
            for (const item of this.config.table.columns) {
                if (item.prop === prop) {
                    sensitiveValue = item.sensitiveValue
                    break
                }
            }
            return sensitiveValue
        },
        handleExport() {
            const params = this.getParams()
            delete params.pageNo
            delete params.pageSize
            this.exportLoading = true
            let exportApi = lsrmExport
            if (this.isSupplier) {
                //LSP
                exportApi = lspExport
            }
            exportApi(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { downUrl, localFileName } = res.data
                        const a = document.createElement('a')
                        a.style.display = 'none'
                        a.download = `${localFileName}.xlsx`
                        a.href = downUrl
                        a.click()
                        this.$message.success('导出成功')
                    }
                })
                .finally(() => {
                    this.exportLoading = false
                })
        },
        handleSelect(val) {
            this.selecteList = val
        },
        handleRecord(row) {
            this.$refs.rdRef.open(row)
            try {
                bigDataLog.sendDetailMessageByKey('bigData-btn-record')
            } catch (e) {}
        },
        pushFn(confirmCodeList) {
            rePush({ confirmCodeList })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('重推成功')
                        this.loadData()
                    }
                })
                .finally(() => {
                    this.repushLoading = false
                })
            try {
                bigDataLog.sendDetailMessageByKey('bigData-btn-repush')
            } catch (e) {}
        },
        handleRepush(row) {
            checkRePush({ confirmCodeList: [row.confirmCode] })
                .then(res => {
                    if (res && +res.code === 0 && res.data.manualResentList && res.data.manualResentList.length) {
                        this.$confirm(
                            '已点击过重推了，是否确认点击?（再次重推用户会收到多条短信内容，<span style="color: red;">请慎重点击</span>）',
                            '提示',
                            {
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                            },
                        ).then(() => {
                            this.pushFn([row.confirmCode])
                        })
                    } else {
                        this.pushFn([row.confirmCode])
                    }
                })
                .catch(e => {
                    this.pushFn([row.confirmCode])
                })
        },
        sendMsg() {
            if (!this.selecteList.length) {
                return this.$message.warning('请选择数据')
            }
            if (this.selecteList.some(item => item.salaryPaydayCode)) {
                return this.$message.warning('请选择发薪日期为空的数据')
            }
            if (this.selecteList.some(item => item.confirmStatus === '6')) {
                return this.$message.warning('请选择未发送短信的数据')
            }
            this.$confirm('是否发送短信？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.repushLoading = true
                sendSms(this.selecteList.map(v => v.confirmCode)).then(res => {
                    if(res && +res.code === 0){
                        this.$message.success('操作成功')
                        this.loadData()
                    }
                }).finally(() => {
                    this.repushLoading = false
                })
            })
        },
        handleRepushAll() {
            if (
                !this.selecteList.length ||
                this.selecteList.some(item => item.confirmStatus === COMFIRM_STATUS.RECEIVED)
            ) {
                return this.$message.warning('请选择【未确认】【未收到】数据进行重推')
            }
            checkRePush({ confirmCodeList: this.selecteList.map(v => v.confirmCode) })
                .then(res => {
                    if (res && +res.code === 0 && res.data.manualResentList && res.data.manualResentList.length) {
                        this.$confirm(
                            '已点击过重推了，是否确认点击?（再次重推用户会收到多条短信内容，<span style="color: red;">请慎重点击</span>）',
                            '提示',
                            {
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                            },
                        ).then(() => {
                            this.repushLoading = true
                            this.pushFn(this.selecteList.map(item => item.confirmCode))
                        })
                    } else {
                        this.repushLoading = true
                        this.pushFn(this.selecteList.map(item => item.confirmCode))
                    }
                })
                .catch(e => {
                    this.repushLoading = true
                    this.pushFn(this.selecteList.map(item => item.confirmCode))
                })
        },
    },
}
</script>
<style lang="less">
.loader-salary-confirm {
    #mPane3 .el-table {
        min-height: calc(100vh - 206px);
        max-height: calc(100vh - 206px);
    }

    #mPane3.loader-salary-confirm-supplier-pane .el-table {
        min-height: calc(100vh - 168px);
        max-height: calc(100vh - 168px);
    }

    .salary-operate-success {
        font-size: 14px;
    }

    .salary-operate-fail {
        font-size: 14px;
        color: #f96c5f;
    }

    .salary-not-operate {
        font-size: 14px;
        color: #00bcbf;
    }
    .tips {
        margin-bottom: 5px;
        font-size: 13px;
        color: #f96c5f;
    }
}
</style>
